import axios from 'axios'

import config from '@app/config'
import { unauthorizedBackendApi } from '@app/services'
import { isAndroidWebView } from '@app/utils'

export const refreshTokenB2C = async () => {
  try {
    const shouldUseMessagesApi = config.identity.isWebView
    const requestData = shouldUseMessagesApi
      ? { clientId: isAndroidWebView ? 'properstar_android' : 'properstar_ios' }
      : {}

    const { data } = shouldUseMessagesApi
      ? await unauthorizedBackendApi.post('/users/refreshB2CToken', requestData)
      : await axios.post('/auth/token', requestData)

    return data
  } catch (error) {
    console.error('Error refreshing token:', error)

    throw error
  }
}
